export default typeof window === "undefined"
  ? null
  : window.location.href.startsWith("https://www.coop.co.uk/blog/")
  ? "//nexus.ensighten.com/co-operative/coop-publish/Bootstrap.js"
  : null;
